import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import { Group } from "./hark";
import InternalRadio from "./Radio";
import Button from "./RadioButton";
import { jsx as _jsx } from "react/jsx-runtime";
var Radio = InternalRadio;
Radio.Button = Button;
Radio.Group = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(Group, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
});
export { Button, Group };
export default Radio;